/* eslint-disable no-nested-ternary */
/* eslint-disable no-empty */
/* eslint-disable camelcase */
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { connect, ConnectedProps } from 'react-redux';
import {
    LayoutMenu,
    LayoutMenuItem,
    LanguageSelector,
    LayoutContentHeader,
    changeLanguage,
} from '@eta/components';
import * as H from 'history';
import { Profile } from 'oidc-client';
import { useLocation } from 'react-router-dom';

import { Header, HeaderUserMenu } from '.';
import { authService } from '../../Security/Security';
import './Layout.scss';
import { MarkDownType } from '../config/constants';
import MarkDown from '../../ContentManagement/Components/MarkDown';
import { EnsureNotSlashAtEnd } from '../../helpers/UIHelpers';
import { ReduxState } from '../reducers';
import { ServiceCreator } from '../Service/client';
import { StatusTypes } from '../Service/proxy';

export interface LayoutProps {
    menuItems: LayoutMenuItem[];
}

export function GetCurrentMenuItemEntry(
    location: H.Location,
    menu: LayoutMenuItem[]
): LayoutMenuItem[] | undefined {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of menu) {
        if (
            item.pathname !== '' &&
            location.pathname.indexOf(item.pathname) !== -1
        ) {
            return [item];
        }
        if (item.subItems) {
            const subarea = GetCurrentMenuItemEntry(location, item.subItems);
            if (subarea) {
                return [item, ...subarea];
            }
        }
    }
    return undefined;
}

const mapStateToProps = (state: ReduxState) => ({
    currentlanguage: state.reduxlanguage.language,
    currentProfile: state.profile.currentProfile,
});

const mapDispatchToProps = {
    dispatchChangeLanguage: changeLanguage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const Layout: FC<PropsWithChildren<LayoutProps> & PropsFromRedux> = (
    props: PropsWithChildren<LayoutProps> & PropsFromRedux
) => {
    const {
        children,
        menuItems,
        currentProfile,
        currentlanguage,
        dispatchChangeLanguage,
    } = props;
    const { t } = useTranslation(['resources', 'common', 'Menu']);
    const [isLoading, setIsLoading] = useState(true);
    const [profile, setProfile] = useState<Profile>();
    const [, setExpiredIn] = useState<number>();
    const [TaxpayerNameAR, setTaxpayerNameAR] = useState<string>();
    const [TaxpayerNameEN, setTaxpayerNameEN] = useState<string>();
    const [RIN, setRIN] = useState<string>();
    const currentMenuEntry = GetCurrentMenuItemEntry(useLocation(), menuItems);
    const [hasMultipleTaxpayers, setHasMultipleTaxpayers] =
        useState<boolean>(false);

    useEffect(() => {
        setTaxpayerNameAR(localStorage.getItem('TaxpayerNameAR') ?? '');
        setTaxpayerNameEN(localStorage.getItem('TaxpayerNameEN') ?? '');
        setRIN(localStorage.getItem('RIN') ?? '');
    }, [profile]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invoicingPortalURL = (window as any)
        .REACT_APP_InvoicingPortalURL as string;

    setTimeout(() => {
        authService.getUser().then((user) => {
            // eslint-disable-next-line camelcase
            setExpiredIn(user?.expires_in);
        });
    }, 1000);

    // const TaxpayerNameAR = localStorage.getItem('TaxpayerNameAR') ?? '';
    // const TaxpayerNameEN = localStorage.getItem('TaxpayerNameEN') ?? '';
    // const RIN = localStorage.getItem('RIN') ?? '';

    authService.getUser().then(async (user) => {
        const client = ServiceCreator.getUserProfileAdminClient();
        if (profile?.name !== user?.profile.name) {
            if (
                RIN !== user?.profile.TaxRin ||
                (!TaxpayerNameEN && !TaxpayerNameAR)
            ) {
                try {
                    const response = await client.getTaxpayerByRinLight(
                        user?.profile.TaxRin ?? null
                    );
                    localStorage.setItem(
                        'TaxpayerNameAR',
                        response.nameSecondaryLang || ''
                    );
                    localStorage.setItem(
                        'TaxpayerNameEN',
                        response.namePrimaryLang || ''
                    );
                    localStorage.setItem(
                        'RIN',
                        response.registrationNumber || ''
                    );
                    // eslint-disable-next-line no-empty
                } catch {}
            }
            setProfile(user?.profile);
        }
    });

    const hasName =
        currentProfile?.taxpayerRepresentative?.lastNameSecondaryLang ||
        currentProfile?.taxpayerRepresentative?.firstNameSecondaryLang;
    const nameFromCurrentProfile = `${
        currentProfile?.taxpayerRepresentative?.lastNameSecondaryLang
            ? `${currentProfile?.taxpayerRepresentative?.firstNameSecondaryLang} `
            : ''
    }${currentProfile?.taxpayerRepresentative?.lastNameSecondaryLang ?? ''}`;
    const location = useLocation();

    useEffect(() => {
        setIsLoading(true);
        const refreshTokenAsync = async () => {
            await authService.refreshToken();
            authService.currentUser = null;
            authService.getUser().then(async (user) => {
                const client = ServiceCreator.getUserProfileAdminClient();

                if (profile?.name !== user?.profile.name) {
                    if (
                        RIN !== user?.profile.TaxRin ||
                        (!TaxpayerNameEN && !TaxpayerNameAR)
                    ) {
                        try {
                            const response = await client.getTaxpayerByRinLight(
                                user?.profile.TaxRin ?? null
                            );
                            localStorage.setItem(
                                'TaxpayerNameAR',
                                response.nameSecondaryLang || ''
                            );
                            localStorage.setItem(
                                'TaxpayerNameEN',
                                response.namePrimaryLang || ''
                            );
                            localStorage.setItem(
                                'RIN',
                                response.registrationNumber || ''
                            );
                            // eslint-disable-next-line no-empty
                        } catch {}
                    }
                    setProfile(user?.profile);
                }
                setIsLoading(false);
            });
        };
        const query = new URLSearchParams(location.search);
        const language = query.get('lng');
        const rin = query.get('rin');
        if (rin !== localStorage.getItem('RIN')) refreshTokenAsync();
        else setIsLoading(false);
        window.history.pushState('object', document.title, location.pathname);
        if (language && language !== currentlanguage.lang) {
            dispatchChangeLanguage(language);
        }
    }, []);

    useEffect(() => {
        const bindingCall = async () => {
            try {
                const client = ServiceCreator.getUserProfileAdminClient();
                const response = await client.getCurrentUserDetails();
                const taxPayerLookups = response.taxpayerRepresentations ?? [];
                const currentDate = new Date();
                const curentTaxPayerID = parseInt(
                    authService?.currentUser?.profile?.TaxId ?? '0',
                    10
                );
                const activeTaxPayerLookups = taxPayerLookups.filter(
                    (taxPayer) =>
                        taxPayer.taxpayerActive &&
                        taxPayer.status === StatusTypes._1 &&
                        taxPayer.taxpayerID !== curentTaxPayerID &&
                        taxPayer.dateActivated !== undefined &&
                        currentDate > taxPayer.dateActivated &&
                        (taxPayer.dateDeactivated === undefined ||
                            currentDate < taxPayer.dateDeactivated)
                );
                const multipleTaxpayersCount = activeTaxPayerLookups.length;
                setHasMultipleTaxpayers(multipleTaxpayersCount > 0);
            } catch {}
        };
        bindingCall();
    }, []);

    return (
        <div className="layout">
            <div className="layout-container">
                <LayoutMenu
                    className="main-menu"
                    menuItems={menuItems}
                    disabled={isLoading}
                    opened
                    closeMenuOnClick={false}
                >
                    {isLoading ? (
                        <div className="layout-container-loading">
                            <Spinner
                                size={SpinnerSize.large}
                                label={t('common:loading')}
                            />
                        </div>
                    ) : (
                        <div
                            className="layout-container-rightPart"
                            data-is-scrollable="true"
                        >
                            <MarkDown Type={MarkDownType.Important} />
                            <MarkDown Type={MarkDownType.Informative} />
                            <Header mainTitle={t('common:Profile')}>
                                <HeaderUserMenu
                                    userName={profile?.name ?? ''}
                                    // eslint-disable-next-line camelcase
                                    preferredUsername={
                                        hasName
                                            ? nameFromCurrentProfile
                                            : profile?.preferred_username ?? ''
                                    }
                                    // eslint-disable-next-line camelcase
                                    // eslint-disable-next-line no-nested-ternary
                                    taxname={
                                        currentlanguage.langIso4
                                            .toLowerCase()
                                            .startsWith('en')
                                            ? TaxpayerNameEN === ''
                                                ? TaxpayerNameAR
                                                : TaxpayerNameEN
                                            : TaxpayerNameAR === ''
                                            ? TaxpayerNameEN
                                            : TaxpayerNameAR
                                    }
                                    hasMultipleTaxpayers={hasMultipleTaxpayers}
                                    actions={[
                                        {
                                            key: 'ViewTaxpayerProfile',
                                            text: t(
                                                'common:viewTaxpayerProfile'
                                            ),
                                            to: '/TaxpayerProfile',
                                            iconName: 'EMI',
                                        },
                                        {
                                            key: 'SwitchTaxpayer',
                                            text: t('common:switchTaxpayer'),
                                            to: '/switchTaxpayer',
                                            iconName: 'Switch',
                                        },
                                        {
                                            key: 'ViewProfile',
                                            text: t('common:viewMyProfile'),
                                            to: '/myProfile',
                                            iconName: 'Contact',
                                        },
                                        {
                                            key: 'ChangeMyPassword',
                                            text: t('common:changeMyPassword'),
                                            to: '/changePassword',
                                            iconName: 'Permissions',
                                        },
                                        {
                                            key: 'signout',
                                            text: t('common:logout'),
                                            to: '/logout',
                                            iconName: 'SignOut',
                                        },
                                    ]}
                                />
                                <LanguageSelector />
                                <a
                                    className="faq"
                                    href={`${EnsureNotSlashAtEnd(
                                        invoicingPortalURL
                                    )}/content?path=faq/home`}
                                >
                                    <span> {t('nav.FAQ')} </span>
                                </a>
                                {/* <NotificationViewer /> */}
                            </Header>
                            <LayoutContentHeader menuEntry={currentMenuEntry} />
                            {children}
                        </div>
                    )}
                </LayoutMenu>
            </div>
        </div>
    );
};
export default connector(Layout);
